/**
 * Promotional cards that are switched off app-wide but kept in the code.
 *
 * `SHOW_REFUNDABLE_PERKS_CARDS` covers two cards on both the public homepage
 * (IndexMinimal.jsx) and the signed-in Home (Home.jsx):
 *   - "Make It Refundable, Get the Perks" (American Airlines Main Cabin Extra)
 *   - "Let Us Treat You" (the $10 Starbucks gift card)
 *
 * Hidden at the founder's request on 2026-10-06. Set it to true to bring both
 * back exactly as they were.
 */
export const SHOW_REFUNDABLE_PERKS_CARDS = false;
